import * as React from 'react';
import { ArrowLeftOutlined } from '@youlify/icons';
import toArray from 'rc-util/lib/Children/toArray';

import type { StepProps } from '.';
import { devUseWarning } from '../_util/warning';

function filter<T>(items: (T | null)[]): T[] {
  return items.filter((item) => item) as T[];
}

export default function useLegacyItems(
  items?: StepProps[],
  children?: React.ReactNode,
  current = 0,
  prefixCls?: string,
  onBack?: (stepIndex: number) => void,
) {
  if (process.env.NODE_ENV === 'test') {
    const warning = devUseWarning('Menu');
    warning.deprecated(!children, 'Step', 'items');
  }

  if (items) {
    return items.map((item, index) => {
      const isNotOverCurrent = index < current!;
      const withBackLabel = isNotOverCurrent && !!item.backLabel;
      const mappingItems = {
        ...item,
        title: withBackLabel ? (
          <div className={`${prefixCls}-item-title-with-back`} onClick={() => onBack?.(index)}>
            <span className={`${prefixCls}-item-title-with-back-title`}>{item.title}</span>
            <span className={`${prefixCls}-item-title-with-back-label`}>
              <ArrowLeftOutlined />
              <span className={`${prefixCls}-item-title-with-back-label-title`}>
                {item.backLabel}
              </span>
            </span>
          </div>
        ) : (
          item.title
        ),
      };
      delete mappingItems.backLabel;
      return mappingItems;
    });
  }

  const childrenItems = toArray(children).map((node) => {
    if (React.isValidElement(node)) {
      const { props } = node as React.ReactElement<StepProps>;
      const item: StepProps = {
        ...props,
      };
      return item;
    }

    return null;
  });

  return filter(childrenItems);
}
